export enum ScheduleTypes {
    WeeklySchedule,
    TemporarySchedule,
    HolidaySchedule,
    ExceptionSchedule,
}
